const siteTagType = {
  methods: {
    getSiteTagType(site) {
      if (site.name.toUpperCase() === 'Aberdeen') return 'warning';
      if (site.name.toUpperCase() === 'Den Helder') return 'red white--text';
      return 'info';
    },
  },
};


export default siteTagType;
